import store from '@/store'
import axios from '@/libs/axios'





export class DashboardService {  


static async getWidgetData(params) {
  

    return new Promise((resolve, reject) => {     
      axios.get(`dashboard/widgets`, { params: params })
        .then(res => resolve(res))
        .catch(reason => reject(reason.response))
    })
  }



  

}